import Head from "next/head"
import { useContext } from "react"
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context"
import { usePriceTag } from "./PriceTag/PriceTag.hook"
import { cleanHtmlFromString, sanitizeHtml } from "@Utils/Functions"



export const FichaStructData = ({prop, mode}) => {

    const { main_domain } = useContext(ConfigStateContext)
    const {data:priceData} = usePriceTag({
        mode:mode,
        ...prop
    })


    const priceObj = () => {
        let currencyID = priceData?.price?.currency?.id
        let currenciesCodes = {
            '1': 'USD', '2': 'UYU', '3': 'PYG',
            '4': 'COP', '5': 'BOB', '6': 'PEN',
        }

        return {
            "@type": "PriceSpecification",
            "price": priceData?.price?.amount,
            "priceCurrency": currenciesCodes[currencyID]
        }
    }


    const jsonData =  {
        "@context": "https://schema.org",
	    "@type": "RentAction",
        "priceSpecification": priceObj(),
        "landlord": {
            "@type":prop?.owner?.__typename == 'RealEstateAgent'? "RealEstateAgent" : "Person",
            "name": prop?.owner?.name,
            "image": prop?.owner?.logo && prop?.owner?.logo.length>0 ? prop?.owner?.logo :null,
            "address": prop?.owner?.address
        },
        "object": {
            "@type": "SingleFamilyResidence",
            "address": prop?.address,
            "geo": {
                "@type": "GeoCoordinates",
                "latitude": prop?.latitude,
                "longitude": prop?.longitude
            }
        },
        "name": prop?.title,
        "url": 'https://'+main_domain+'/'+prop?.link,
        "image": prop?.img,
        "description": sanitizeHtml(cleanHtmlFromString(prop?.description))
        
    }

    return <>
        <Head>
             <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(jsonData),
                }}></script>
        </Head>
    </>
}
